var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "331.9px",
    height: "38px",
    viewBox: "0 0 331.9 38",
    style: {
      enableBackground: "new 0 0 331.9 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos_x2F_CON_x5F_blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M30.8,15.4l-8.1-4.6V22v0.3l-3.6,2l-6.8-6.6l2.4,9.2l-3.6,2.2l-9.9-5.8v9.2c0,4,2.9,5.6,6.3,3.6 l23.5-13.5C34.3,20.6,34.3,17.3,30.8,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M18.6,17.8V8.3L7.3,1.9C3.9-0.2,1,1.6,1,5.5v13.1l8.4,4.8L6.9,12.8l3.9-2.3L18.6,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st0",
    d: "M64.5,29.5H54.1c-4,0-7.3-2.7-7.3-6.2v-8.6c0-3.3,3.2-6,7.3-6.2h10.4c3.9,0,7.2,2.7,7.3,6.2v0.4 h-4.3v-0.4c0-1.4-1.4-2.4-3-2.4H54.1c-1.7,0-3,1.2-3,2.4v8.6c0,1.4,1.4,2.4,3,2.4h10.4c1.7,0,3-1.2,3-2.4v-0.4h4.2v0.4 C71.8,26.6,68.5,29.5,64.5,29.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st0",
    d: "M82.1,12.1c-1.7,0-3,1.2-3,2.4v8.6c0,1.4,1.4,2.4,3,2.4h10.4c1.7,0,3-1.2,3-2.4v-8.6 c0-1.4-1.4-2.4-3-2.4H82.1z M92.4,29.5H82.1c-4,0-7.3-2.7-7.3-6.2v-8.6c0-3.5,3.3-6.2,7.3-6.2h10.4c4,0,7.3,2.9,7.3,6.2v8.6 C99.8,26.8,96.5,29.5,92.4,29.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    className: "st0",
    points: "128.3,29.5 124.3,29.5 107.6,14.4 107.6,29.5 103.4,29.5 103.4,8.5 107.4,8.5  124.3,23.3 124.3,8.5 128.4,8.5 128.4,29.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "st0",
    points: "146.7,29.5 139.7,29.5 130.5,8.5 134.8,8.5 142.3,25.9 144.1,25.9 151.6,8.5 155.9,8.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st0",
    d: "M163.6,12.1c-1.7,0-3,1.2-3,2.4v8.6c0,1.4,1.4,2.4,3,2.4h10.4c1.7,0,3-1.2,3-2.4v-8.6 c0-1.4-1.4-2.4-3-2.4H163.6z M174.1,29.5h-10.4c-4,0-7.3-2.7-7.3-6.2v-8.6c0-3.5,3.3-6.2,7.3-6.2h10.4c4,0,7.3,2.9,7.3,6.2v8.6 C181.4,26.8,178.1,29.5,174.1,29.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    className: "st0",
    points: "196.8,29.5 192.7,29.5 192.7,12.1 182.3,12.1 182.3,8.5 207.4,8.5 207.4,12.1 197,12.1  197,29.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    className: "st0",
    points: "234.4,29.5 230.2,29.5 230.2,20.9 213.7,20.9 213.7,29.5 209.5,29.5 209.5,8.5  213.7,8.5 213.7,17.1 230.2,17.1 230.2,8.5 234.4,8.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    className: "st0",
    points: "263.4,29.5 238.3,29.5 238.3,8.5 263.4,8.5 263.4,12.1 242.5,12.1 242.5,17.1  259.9,17.1 259.9,20.7 242.5,20.7 242.5,25.8 263.4,25.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "st0",
    d: "M270.6,20h13.5c1.7,0,3-1.2,3-2.4v-2.9c0-1.4-1.4-2.4-3-2.4h-13.5V20z M291.7,29.5h-5l-4.8-5.8 h-11.4v5.8h-4.2v-21h17.7c4,0,7.3,2.9,7.3,6.2v2.9c0,2.4-1.9,4.8-4.6,5.8L291.7,29.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    className: "st0",
    points: "323.1,29.5 319,29.5 319,15.1 308.9,27.2 298.8,15.1 298.8,29.5 294.6,29.5 294.6,8.5  298.6,8.5 308.9,20.7 319.1,8.5 323.1,8.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    className: "st0",
    d: "M328,9.8h0.3c0.3,0,0.6-0.1,0.6-0.3s-0.2-0.3-0.5-0.3H328V9.8z M328,11.2h-0.6V8.7 c0.3-0.1,0.5-0.1,0.9-0.1s0.7,0.1,0.8,0.2c0.2,0.1,0.3,0.3,0.3,0.5s-0.2,0.5-0.5,0.6c0.3,0.1,0.3,0.3,0.4,0.6 c0.1,0.3,0.1,0.5,0.2,0.6H329c-0.1-0.1-0.1-0.3-0.2-0.6c-0.1-0.3-0.2-0.4-0.5-0.4H328V11.2z M326.6,9.9c0,1.1,0.8,1.9,1.9,1.9 s1.9-0.8,1.9-1.9c0-1.1-0.8-1.9-1.9-1.9S326.6,8.8,326.6,9.9z M330.9,9.9c0,1.4-1.1,2.4-2.4,2.4c-1.4,0-2.4-1.1-2.4-2.4 c0-1.4,1.1-2.5,2.4-2.5C329.8,7.5,330.9,8.6,330.9,9.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConBlue);
export default __webpack_public_path__ + "static/media/CON_blue.0f17af9e40e59b926a8aea609534fca7.svg";
export { ForwardRef as ReactComponent };